export default __webpack_public_path__ + "static/media/person-floor.b1c58db6.svg";